import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpService } from '../../services/http.service';
import { finalize, map, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
    CalculatePriceLiteResponse,
    OfferPriceCalculationParams,
    OfferPriceCalculationResponse,
    PriceLiteParams,
    PriceSummary,
} from './price-summary.model';

@Injectable({
    providedIn: 'root',
})
export class PriceSummaryDataService {
    public isPriceSummaryLoading$: Subject<{ value: boolean }> = new Subject<{ value: boolean }>();

    public hasErrors$: Subject<{ value: boolean }> = new Subject<{ value: boolean }>();

    private lastPriceSummary: PriceSummary;

    constructor(private httpService: HttpService) {}

    public fetchOfferPrice(payload: OfferPriceCalculationParams): Observable<PriceSummary> {
        this.onStart();
        const url = `${environment.http.quotation}price/calculate`;
        const result: Observable<PriceSummary> = this.httpService
            .post<OfferPriceCalculationResponse>(url, payload)
            .pipe(
                map(({ offer, prices }) => {
                    return {
                        isFull: true,
                        grossPrices: offer.items.map((item) => ({
                            material: item.material,
                            gross: item.grossPrice,
                        })),
                        prices,
                    };
                })
            );
        return this.onEnd(result);
    }

    public fetchPriceSummaryLite(params: PriceLiteParams): Observable<PriceSummary> {
        this.onStart();
        const url = `${environment.http.quotation}price/calculate/lite`;

        const result: Observable<PriceSummary> = this.httpService
            .post<CalculatePriceLiteResponse>(url, params)
            .pipe(map((res) => ({ ...res, isFull: false })));

        return this.onEnd(result);
    }

    public getLastPriceSummary() {
        return this.lastPriceSummary;
    }

    private onStart() {
        this.isPriceSummaryLoading$.next({ value: true });
    }

    private onEnd(result: Observable<PriceSummary>) {
        return result.pipe(
            tap((result) => (this.lastPriceSummary = result)),
            finalize(() => {
                this.isPriceSummaryLoading$.next({ value: false });
            })
        );
    }
}
